export default __webpack_public_path__ + "static/media/report-inspection-score.e8795e65.svg";